export default __webpack_public_path__ + "static/media/onboardingPoster.aa8b09e8.jpg";